import { useEffect, useRef, useState } from 'react';

const slides = [
  {
    title: "기업단기자금",
    subtitle: "기업들의 자금 융통을 위한 간편 대출",
    amount: "최대 10억원",
    tags: ["#자금융통", "#기업", "#간편대출"],
    image: "https://readdy.ai/api/search-image?query=Modern%20glass%20skyscraper%20building%20exterior%2C%20corporate%20financial%20district%2C%20blue%20sky%20with%20soft%20clouds%2C%20professional%20business%20atmosphere%2C%20bright%20natural%20lighting%2C%20high%20quality%20architectural%20photography%2C%20minimal%20clean%20aesthetic&width=600&height=450&seq=dukk-slide-01&orientation=landscape",
  },
  {
    title: "법인사업자대출",
    subtitle: "법인 대표님들을 위한 든든한 사업자대출",
    amount: "최대 10억원",
    tags: ["#법인대표", "#사업자대출", "#든든한자금"],
    image: "https://readdy.ai/api/search-image?query=Executive%20boardroom%20with%20floor%20to%20ceiling%20windows%2C%20modern%20conference%20table%2C%20city%20skyline%20view%2C%20blue%20tinted%20glass%2C%20professional%20corporate%20interior%2C%20bright%20natural%20light%2C%20clean%20minimal%20design&width=600&height=450&seq=dukk-slide-02&orientation=landscape",
  },
  {
    title: "개인사업자대출",
    subtitle: "개인사업자 사장님을 위한 넉넉한 맞춤대출",
    amount: "최대 10억원",
    tags: ["#개인사업자", "#맞춤대출", "#당일승인"],
    image: "https://readdy.ai/api/search-image?query=Entrepreneur%20working%20at%20modern%20desk%20with%20laptop%2C%20bright%20contemporary%20office%20space%2C%20clean%20workspace%2C%20professional%20business%20owner%2C%20warm%20natural%20lighting%2C%20minimal%20interior%20design&width=600&height=450&seq=dukk-slide-03&orientation=landscape",
  },
  {
    title: "자영업자대출",
    subtitle: "매출만 확인되면 OK! 자영업자 든든 지원",
    amount: "최대 5억원",
    tags: ["#자영업자", "#매출기준", "#빠른송금"],
    image: "https://readdy.ai/api/search-image?query=Creative%20freelancer%20workspace%20with%20laptop%20and%20coffee%2C%20modern%20cafe%20interior%2C%20soft%20blue%20tones%2C%20natural%20window%20light%2C%20clean%20aesthetic%2C%20self%20employed%20professional%20atmosphere&width=600&height=450&seq=dukk-slide-04&orientation=landscape",
  },
];

export default function HeroSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const goToSlide = (index: number) => {
    setActiveIndex(index);
    if (intervalRef.current) clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % slides.length);
    }, 4000);
  };

  const current = slides[activeIndex];

  return (
    <section id="hero" className="relative w-full h-[600px] md:h-[720px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stunning%20modern%20financial%20cityscape%20at%20golden%20hour%2C%20glass%20skyscrapers%20reflecting%20blue%20sky%2C%20professional%20business%20district%20panorama%2C%20wide%20angle%20city%20view%2C%20breathtaking%20urban%20landscape%2C%20bright%20and%20clean%20aesthetic%2C%20editorial%20photography&width=1600&height=900&seq=dukk-hero-bg&orientation=landscape"
          alt="hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-primary-600/80" />
        <div className="absolute inset-0 bg-primary-900/40" />
      </div>

      <div className="relative z-10 h-full flex items-center">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
            <div className="flex-1 text-center lg:text-left">
              <p className="text-sm md:text-base font-label font-medium text-white/80 mb-4 tracking-wide">
                모든 사업자를 위한 대출, <strong className="text-white font-bold">DUKKEOBI LOAN</strong>
              </p>
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
                두꺼비대출은
                <br />
                대표님께{' '}
                <span className="text-accent-300">딱 맞는 상품</span>
                을
                <br className="hidden lg:block" />
                찾아드립니다
              </h1>
              <div className="flex flex-wrap justify-center lg:justify-start gap-2 md:gap-3 mb-8">
                {['#법인사업자', '#개인사업자', '#최적의한도', '#빠른당일승인'].map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-white/15 backdrop-blur-sm text-white text-xs md:text-sm font-label font-medium"
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <button
                onClick={() => document.querySelector('#consult')?.scrollIntoView({ behavior: 'smooth' })}
                className="inline-flex items-center gap-2 px-6 md:px-8 py-3 md:py-4 rounded-full bg-white text-primary-700 font-label font-semibold text-sm md:text-base hover:bg-background-50 transition-all duration-300 whitespace-nowrap"
              >
                <i className="ri-search-line w-5 h-5 flex items-center justify-center" />
                내 사업장에 가장 적합한 대출 상품은?
              </button>
            </div>

            <div className="w-full max-w-sm lg:max-w-md">
              <div className="relative bg-white/10 backdrop-blur-md rounded-2xl md:rounded-3xl p-4 md:p-6 border border-white/20">
                <div className="relative h-[280px] md:h-[340px] rounded-xl md:rounded-2xl overflow-hidden mb-4">
                  {slides.map((slide, index) => (
                    <div
                      key={slide.title}
                      className={`absolute inset-0 transition-opacity duration-700 ${
                        index === activeIndex ? 'opacity-100' : 'opacity-0'
                      }`}
                    >
                      <img
                        src={slide.image}
                        alt={slide.title}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  ))}
                </div>

                <div className="text-center">
                  <h3 className="text-lg md:text-xl font-heading font-bold text-white mb-1 transition-all duration-500">
                    {current.title}
                  </h3>
                  <p className="text-sm text-white/70 font-label mb-2">{current.subtitle}</p>
                  <strong className="text-xl md:text-2xl font-heading font-bold text-accent-300 block mb-3">
                    {current.amount}
                  </strong>
                  <div className="flex justify-center gap-2 flex-wrap">
                    {current.tags.map((tag) => (
                      <span key={tag} className="text-xs text-white/60 font-label">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="flex justify-center gap-2 mt-4">
                  {slides.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => goToSlide(index)}
                      className={`w-2 h-2 md:w-2.5 md:h-2.5 rounded-full transition-all duration-300 ${
                        index === activeIndex ? 'bg-white w-6 md:w-8' : 'bg-white/40'
                      }`}
                      aria-label={`슬라이드 ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}